import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const SchoolInformation = () => {
    useEffect(() => {
        document.title = 'School Information -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  About Us</li>
                 <li>School Information</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> School Information </h1>
                    </div>
                </div>
                <div className="row schoolinfo">
            <div className="col-lg-6">
                   <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Information-of-the-School.pdf" target="_blank">Click here to view - Information of the School  </Link></div>
                </div>
                 {/* <div className="col-lg-6">
                   <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Affiliation Bye-Laws.pdf" target="_blank">Click here to view : Section (2.4.7(b)) of Affiliation Bye-Laws : Written Declaration  </Link></div>
                </div>
                 <div className="col-lg-6">
                   <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Self Affidavit.pdf" target="_blank">Click here to view - Self Affidavit of school  </Link></div>
                </div>
                 <div className="col-lg-6">
                   <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Status of Affiliation.pdf" target="_blank">Click here to view - Period / Status of Affiliation  </Link></div>
                </div>
                 <div className="col-lg-6">
                   <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Teacher's Qualification.pdf" target="_blank">Click here to view - Teacher's Qualification and Training  </Link></div>
                </div>*/}
                 <div className="col-lg-6">
                   <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Norms for fixing school fees.pdf" target="_blank"> Click here to view - Norms for fixing school fees </Link></div>
                </div>
       {/*   <div className="col-lg-6">
                   <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Details of Infrastructure.pdf" target="_blank">Click here to view - Details of Infrastructure  </Link></div>
                </div>
                 <div className="col-lg-6">
                   <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Annual Report.pdf" target="_blank">Click here to view - Annual Report 2018-19  </Link></div>
                </div>
                <div className="col-lg-6">
            <div className="linktab"><Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Book List 2024-2025.pdf" target="_blank"> Click here to view - Book List 2024-2025 </Link></div> 
            </div>*/}
            <p>As per the circular no. DE.15(305)/PSB/2020/Pt.File-III/4399-4406 dated 02 Aug 2024, NCERT books are being followed in our school. This is in strict compliance with the prescribed educational guidelines.</p>
                
               </div>
            </div>
        </div>
     </>
  )
}

export default SchoolInformation